import { isArray, isFunction } from "lodash";

const enhanceFunction = (interpolation, defaultValues) => {
  const functionWithEnhancedResult = (props) => {
    const functionResult = interpolation({ ...defaultValues, ...props });
    return enhance(functionResult, defaultValues);
  };

  return functionWithEnhancedResult;
};

export const enhance = (interpolation, defaultValues) => {
  if (isArray(interpolation)) {
    return interpolation.map(item => enhance(item, defaultValues));
  }

  if (isFunction(interpolation)) {
    return enhanceFunction(interpolation, defaultValues);
  }

  return interpolation;
};